import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import RequestFormHeader from '../RequestFormHeader/RequestFormHeader';

interface RequestFormSectionProps extends PropsWithChildren {
    className?: string;
    header: string;
}

const Root = styled.section``;

const RequestFormSection: FC<RequestFormSectionProps> = (props) => {
    const { className, header, children } = props;

    return (
        <Root className={className}>
            <RequestFormHeader>{header}</RequestFormHeader>

            {children}
        </Root>
    );
};

export default RequestFormSection;
